import React, { useState, useEffect } from "react";
import { useSessionTimeout } from "../../hooks/useSessionTimeout";

export default function SessionTimeoutModal() {
  const [showWarning, setShowWarning] = useState(false);
  const [countdown,   setCountdown]   = useState(300); // 5 min in seconds
  const countRef = React.useRef(null);

  const { stayActive } = useSessionTimeout({
    onWarning: () => {
      setShowWarning(true);
      setCountdown(300);
      countRef.current = setInterval(() => {
        setCountdown(c => {
          if (c <= 1) { clearInterval(countRef.current); return 0; }
          return c - 1;
        });
      }, 1000);
    },
    onLogout: () => {
      setShowWarning(false);
      clearInterval(countRef.current);
    },
  });

  const handleStay = () => {
    setShowWarning(false);
    clearInterval(countRef.current);
    stayActive();
  };

  if (!showWarning) return null;

  const mins = Math.floor(countdown / 60);
  const secs = countdown % 60;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",
      display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}}>
      <div style={{background:"var(--surface)",border:"1px solid var(--border)",
        borderRadius:14,padding:"28px 32px",maxWidth:400,width:"90%",textAlign:"center"}}>
        <div style={{fontSize:36,marginBottom:12}}>⚠️</div>
        <div style={{fontSize:17,fontWeight:700,color:"var(--text)",marginBottom:8}}>
          Session Expiring Soon
        </div>
        <div style={{fontSize:13,color:"var(--text-3)",marginBottom:16,lineHeight:1.6}}>
          For HIPAA security, your session will automatically log out after 15 minutes of inactivity.
          You will be logged out in:
        </div>
        <div style={{fontSize:36,fontWeight:800,
          color:countdown<60?"var(--red)":"#d97706",marginBottom:20,fontFamily:"monospace"}}>
          {String(mins).padStart(2,"0")}:{String(secs).padStart(2,"0")}
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"center"}}>
          <button onClick={handleStay}
            style={{padding:"10px 28px",borderRadius:9,cursor:"pointer",
              border:"1px solid rgba(5,150,105,.4)",background:"rgba(5,150,105,.15)",
              color:"#059669",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>
            ✓ Stay Logged In
          </button>
        </div>
        <div style={{marginTop:12,fontSize:11,color:"var(--text-3)"}}>
          HIPAA § 164.312(a)(2)(iii) — Automatic Logoff
        </div>
      </div>
    </div>
  );
}
